import React, { useEffect } from "react";
import { notification } from "antd";
import useAsync from "./useAsync";
import { http } from "../api/http";

export default function useDocumentCreator(initialState = {}) {
  const { path = null } = initialState;

  const [url, setUrl] = React.useState(path);
  const [doc, setDoc] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [loadingGet, setLoadingGet] = React.useState(false);
  const [done, setDone] = React.useState(false);

  const { isLoading, isSuccess, run, error } = useAsync();

  useEffect(() => {
    const handlerErrorBlod = async () => {
      // Handle the blob response
      const isJsonBlob = data =>
        data instanceof Blob && data.type === "application/json";
      const responseData = isJsonBlob(error?.data)
        ? await error?.data?.text()
        : error?.data || {};

      const responseJson =
        typeof responseData === "string"
          ? JSON.parse(responseData)
          : responseData;
      if (typeof responseJson.message === "string") {
        notification.error({ message: responseJson.message, duration: 6 });
      } else if (Array.isArray(responseJson.message)) {
        responseJson.message.map(mess =>
          notification.error({ message: mess, duration: 6 }),
        );
      }

      setLoading(false);
    };

    if (error !== null) {
      handlerErrorBlod();
    }
  }, [error]);

  const blobToBrowerFile = async (
    data,
    fileName,
    mimetype = "application/pdf",
    callback,
  ) => {
    const file = new Blob([data], {
      type: data.type,
      fileName: fileName,
    });
    //Build a URL from the file

    const fileURL = URL.createObjectURL(file);

    const link = document.createElement("a");
    link.href = fileURL;

    if (mimetype === "application/pdf") {
      window.open(link.href, "_blank").focus();
    } else {
      link.setAttribute("download", fileName);
      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    }

    setLoadingGet(false);
    callback();
    return true;
  };

  const downloadPdf = async (_id, fileName, mimetype, callback) => {
    setLoadingGet(true);
    try {
      const response = await http.post(
        `/documents/${_id}/buffer`,
        { someData: {} },
        { responseType: "blob" },
      );

      if (response.status === 200) {
        await blobToBrowerFile(response.data, fileName, mimetype, callback);
      }
    } catch (e) {
      console.log(e);
      setLoadingGet(false);
    }
  };

  function handleCreateAndGet(
    body,
    url,
    get = true,
    buffer = false,
    callback = () => {},
  ) {
    setLoading(true);
    let params = {};
    if (buffer) {
      params.responseType = "blob";
    }

    return run(
      http.post(url, body, params).then(res => {
        //console.log(res, res.headers['content-type']);
        // content-type: "application/pdf"

        // ||
        //           res.headers['content-type'] === 'application/json; charset=utf-8'
        if (res.headers["content-type"] === "application/pdf") {
          blobToBrowerFile(
            res.data,
            "facture.pdf",
            res.headers["content-type"],
            callback,
          );
          setLoading(false);
          // Buffer
        } else if (res.headers["content-type"] === "application/zip") {
          blobToBrowerFile(
            res.data,
            "factures.zip",
            res.headers["content-type"],
            callback,
          );
          setLoading(false);
        } else {
          setDoc(res.data);
          if (get) {
            downloadPdf(
              res.data._id,
              res.data.name,
              res.headers["content-type"],
              callback,
            );
          }
          setLoading(false);
          return res.data;
        }
      }),
    );
  }

  return [downloadPdf, handleCreateAndGet, loading, setUrl, doc, done];
}
